function injectStyle (ssrContext) {
  require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-a56a9e74\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=jm8y42ziic!../../../node_modules/string-replace-webpack-plugin/loader.js?id=ilk81eo7m5!./searchItemTwitter.vue")
}
var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=jm8y42ziic!../../../node_modules/string-replace-webpack-plugin/loader.js?id=ilk81eo7m5!./searchItemTwitter.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-a56a9e74\",\"hasScoped\":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=jm8y42ziic!../../../node_modules/string-replace-webpack-plugin/loader.js?id=ilk81eo7m5!./searchItemTwitter.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a56a9e74",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/search/searchItemTwitter.vue
// module id = 407
// module chunks = 1